var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"animated-bar"},_vm._l((5),function(n){return _c('div',{key:n,staticClass:"animated-image"},[_c('img',{staticClass:"current-image",attrs:{"src":_vm.imageUrls[n - 1],"alt":""}}),_c('img',{staticClass:"next-image",attrs:{"src":_vm.nextImageUrls[n - 1],"alt":"","data-active":_vm.transitioning ? 'true' : 'false'}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }